import React, { useEffect, useState } from "react";

import logoIcon from "../assets/logo.png";
import logoText from "../assets/image.png";
import CtaButton from "./CtaButton";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // تحميل التطبيق
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/tabkhatna-1.apk";
    link.download = "tabkhatna.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navItems = [
    { label: "الرئيسية", href: "#home" },
    { label: "الأقسام", href: "#categories" },
    { label: "ليش طبختنا؟", href: "#features" },
    { label: "كيف تشتغل؟", href: "#how-it-works" },
    { label: "الأسئلة الشائعة", href: "#faq" },
  ];

  const scrolledLinkClass = scrolled
    ? "text-[#281d14] hover:text-[#df0018]"
    : "text-white hover:text-[#f5d5d5]";

  return (
    <header
      dir="rtl"
      className={`
        fixed
        top-0
        left-0
        z-50
        font-['Cairo']

        flex
        h-[80px]
        w-full
        items-center
        justify-between

        box-border
        px-[90px]
        py-5

        border-b-[0.8px]

        transition-colors
        duration-300

        ${
          scrolled
            ? "bg-white border-[#e5e5e5]"
            : "bg-[rgba(40,29,20,0.25)] border-[rgba(249,244,232,0.15)]"
        }

        max-[900px]:px-10

        max-[600px]:h-[64px]
        max-[600px]:px-4

        max-[380px]:px-3
      `}
    >
      <style>{`
        @keyframes menuPanelIn {
          from {
            opacity: 0;
            transform: translateX(40px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes menuItemIn {
          from {
            opacity: 0;
            transform: translateX(25px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes menuOverlayIn {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }
      `}</style>

      {/* Logo */}
      <div className="flex items-center gap-0 shrink-0 min-w-0">
        <img
          src={logoIcon}
          alt="أيقونة طبختنا"
          className={`
            w-[60px]
            h-[60px]
            object-contain
            -ml-3
            shrink-0

            max-[600px]:w-[38px]
            max-[600px]:h-[38px]
            max-[600px]:-ml-2
          `}
        />

        <img
          src={logoText}
          alt="طبختنا"
          className={`
            w-[110px]
            h-[45px]
            object-contain
            block
            shrink-0

            max-[600px]:w-[70px]
            max-[600px]:h-[28px]
          `}
        />
      </div>

      {/* Desktop Navigation */}
      <nav
        dir="rtl"
        className="
          hidden
          min-[601px]:flex
          absolute
          left-1/2
          -translate-x-1/2
          items-center
          gap-[28px]
          whitespace-nowrap
        "
      >
        {navItems.map(function (item) {
          const linkClassName =
            "no-underline text-[13px] font-semibold whitespace-nowrap transition-colors duration-300 " +
            scrolledLinkClass;

          return React.createElement(
            "a",
            {
              key: item.href,
              href: item.href,
              onClick: closeMenu,
              className: linkClassName,
            },
            item.label
          );
        })}
      </nav>

      {/* Header Buttons */}
      <div
        className="
          flex
          items-center
          gap-4
          shrink-0

          max-[600px]:gap-[6px]
          max-[380px]:gap-1
        "
      >
        {/* Main CTA */}
        <CtaButton
          onClick={() => {
            closeMenu();
            handleDownload();
          }}
        />

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="فتح القائمة"
          className={`
            relative

            w-11
            h-11
            p-0

            border

            ${
              menuOpen
                ? "bg-[#df0018] border-[#df0018]"
                : scrolled
                ? "bg-[rgba(40,29,20,0.06)] border-[rgba(40,29,20,0.12)]"
                : "bg-[rgba(255,255,255,0.08)] border-[rgba(255,255,255,0.18)]"
            }

            backdrop-blur-[10px]
            rounded-full

            flex
            flex-col
            items-center
            justify-center

            gap-[5px]
            cursor-pointer
            shrink-0

            transition-all
            duration-300

            hover:-translate-y-px

            max-[600px]:w-9
            max-[600px]:h-9

            max-[380px]:w-8
            max-[380px]:h-8

            min-[601px]:hidden
          `}
        >
          <span
            className={`
              block
              w-[18px]
              h-[2px]
              rounded-full
              transition-all
              duration-300

              ${
                menuOpen
                  ? "bg-white rotate-45 translate-y-[7px]"
                  : scrolled
                  ? "bg-[#281d14]"
                  : "bg-white"
              }

              max-[600px]:w-[16px]
            `}
          />

          <span
            className={`
              block
              w-[18px]
              h-[2px]
              rounded-full
              transition-all
              duration-300

              ${
                menuOpen
                  ? "opacity-0"
                  : scrolled
                  ? "bg-[#281d14]"
                  : "bg-white"
              }

              max-[600px]:w-[16px]
            `}
          />

          <span
            className={`
              block
              w-[18px]
              h-[2px]
              rounded-full
              transition-all
              duration-300

              ${
                menuOpen
                  ? "bg-white -rotate-45 -translate-y-[7px]"
                  : scrolled
                  ? "bg-[#281d14]"
                  : "bg-white"
              }

              max-[600px]:w-[16px]
            `}
          />
        </button>
      </div>

      {/* NMO Style Menu */}
      {menuOpen && (
        <>
          {/* Dark Overlay */}
          <div
            onClick={closeMenu}
            className="
              fixed
              inset-0
              z-[-1]

              bg-[rgba(20,14,10,0.55)]
              backdrop-blur-[3px]

              min-[601px]:hidden

              animate-[menuOverlayIn_250ms_ease-out]
            "
          />

          {/* Menu Panel */}
          <nav
            dir="rtl"
            className="
              fixed
              top-0
              right-0
              z-[100]

              h-screen
              w-[420px]

              bg-[#281d14]
              text-white

              flex
              flex-col

              box-border
              px-[45px]
              py-[35px]

              shadow-[-20px_0_60px_rgba(0,0,0,0.25)]

              animate-[menuPanelIn_350ms_ease-out]

              max-[600px]:w-full
              max-[600px]:px-6
              max-[600px]:py-6
            "
          >
            {/* Menu Top */}
            <div
              className="
                flex
                items-center
                justify-between

                pb-8

                border-b
                border-[rgba(255,255,255,0.12)]
              "
            >
              <div className="flex items-center gap-2">
                <img
                  src={logoIcon}
                  alt=""
                  className="
                    w-[42px]
                    h-[42px]
                    object-contain
                  "
                />

                <img
                  src={logoText}
                  alt="طبختنا"
                  className="
                    w-[82px]
                    h-[34px]
                    object-contain
                  "
                />
              </div>

              {/* Close */}
              <button
                onClick={closeMenu}
                aria-label="إغلاق القائمة"
                className="
                  w-11
                  h-11

                  rounded-full

                  border
                  border-[rgba(255,255,255,0.18)]

                  bg-[rgba(255,255,255,0.05)]

                  text-white

                  flex
                  items-center
                  justify-center

                  cursor-pointer

                  transition-all
                  duration-300

                  hover:bg-[#df0018]
                  hover:border-[#df0018]
                "
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>

            {/* Menu Label */}
            <div className="pt-10 pb-6">
              <span
                className="
                  text-[11px]
                  uppercase
                  tracking-[3px]
                  text-[#df0018]
                  font-semibold
                "
              >
                القائمة
              </span>
            </div>

            {/* Links */}
            <div className="flex flex-col">
              {navItems.map(function (item, index) {
                return (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={closeMenu}
                    className="
                      group
                      no-underline

                      flex
                      items-center
                      justify-between

                      py-[18px]

                      border-b
                      border-[rgba(255,255,255,0.10)]

                      text-white

                      transition-all
                      duration-300

                      hover:text-[#df0018]

                      animate-[menuItemIn_450ms_ease-out_both]
                    "
                    style={{
                      animationDelay: `${100 + index * 70}ms`,
                    }}
                  >
                    <div className="flex items-center gap-5">
                      <span
                        className="
                          text-[11px]
                          font-medium
                          text-[rgba(255,255,255,0.35)]
                          group-hover:text-[#df0018]
                          transition-colors
                          duration-300
                        "
                      >
                        0{index + 1}
                      </span>

                      <span
                        className="
                          text-[22px]
                          font-semibold
                          tracking-[-0.4px]

                          max-[600px]:text-[20px]
                        "
                      >
                        {item.label}
                      </span>
                    </div>

                    <span
                      className="
                        text-[22px]
                        text-[rgba(255,255,255,0.35)]

                        transition-all
                        duration-300

                        group-hover:text-[#df0018]
                        group-hover:-translate-x-1
                      "
                    >
                      ←
                    </span>
                  </a>
                );
              })}
            </div>

            {/* Bottom */}
            <div
              className="
                mt-auto

                pt-6

                border-t
                border-[rgba(255,255,255,0.10)]
              "
            >
              <p
                className="
                  m-0

                  text-[11px]
                  leading-6

                  text-[rgba(255,255,255,0.45)]

                  font-medium
                "
              >
                طبختنا
                <br />
                كل وصفة بتبدأ من هون.
              </p>
            </div>
          </nav>
        </>
      )}
    </header>
  );
}

export default Header;